module.exports = __webpack_public_path__ + "img/ios.587fc9d5.png";